import { orgSelectors } from 'ducks/orgs'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useGetSupplierConfig } from './useGetSupplierConfig'

const useQuoteReviewSuppliers = () => {
  const supplierPreferences = useSelector(orgSelectors.getOrgSupplierPreferences)
  const { getPreferenceSupplierConfig } = useGetSupplierConfig()

  const hasPreference = (supplierPreferences?.length ?? 0) > 0

  const filteredSuppliers = useMemo(
    () => getPreferenceSupplierConfig({ quoteReviewOnly: true }),
    [getPreferenceSupplierConfig]
  )

  const defaultSupplierFilterKey = filteredSuppliers[0]?.filterKey ?? ''

  return { filteredSuppliers, defaultSupplierFilterKey, hasPreference }
}

export default useQuoteReviewSuppliers
